import {CONSULTATION_KEY_TYPE, CONSULTATION_TARGET_KEY_TYPE} from "@/shared/model";
import * as z from "zod";

const schema = z.object({
	managerId: z.string(), // 담당자 - 자동입력
	taxAccountantId: z.string(), // 세무사
	visitedAt: z.string(), // 면담일시 - YYYY-MM-dd HH:mm
	wroteDate: z.string(), // 작성일자 - 자동입력
	visitPurpose: CONSULTATION_KEY_TYPE.nullable(), // 유형
	visitPurposeDetail: CONSULTATION_TARGET_KEY_TYPE.nullable(), // 구분
	content: z.string().nullable(),
	recommendedTaxAccountantId: z.string().nullable(),
	recommendedCustomerIds: z.array(z.string()).nullable(),
	files: z.array(z.string()).nullable()
});

const model = schema.transform((values) => ({
	...values
}));

export const VisitHistoryModifyModel = {schema, model};
export type IVisitHistoryModifyModel = z.infer<typeof VisitHistoryModifyModel.model>;

export const DEFAULT_VISIT_HISTORY_MODIFY: IVisitHistoryModifyModel = {
	managerId: "",
	taxAccountantId: "",
	visitedAt: "",
	wroteDate: "",
	visitPurpose: null,
	visitPurposeDetail: null,
	content: "",
	recommendedTaxAccountantId: null,
	recommendedCustomerIds: [],
	files: []
};
